import React from "react";

export default function Banner() {
  return (
    <div className="banner">
      <div className="banner__content">
        <h2>Let's Work Together</h2>
        <a href="mailto:bahalexa@hotmail.com">Say hello</a>
      </div>{" "}
    </div>
  );
}
